/**
 * Show a button when the page is scrolled down.
 * Hide it when the page is scrolled all the way up.
 */

define('libs/scrolltopbutton',[],function() {

    'use strict';

    var SETTINGS = {
        activeClass: 'is-active',
        showAtOffset: 10 // show the button when the pages is scrolled down this many pixels.
    };

    var ScrollTop = function(element, settings) {
        this.settings = $.extend({}, SETTINGS, settings || {});
        this.$element = $(element);
        this.win = $(window);

        this.win.on('scroll', this.onScroll.bind(this));
        this.onScroll();
    };

    /**
     * When the window scrolls, check if we need to hide or show the button.
     */
    ScrollTop.prototype.onScroll = function() {
        var offset = this.win.scrollTop();
        if (!this.active && offset >= this.settings.showAtOffset) {
            this.show();
        } else if (this.active && offset < this.settings.showAtOffset) {
            this.hide();
        }
    };

    /**
     * Show the button.
     */
    ScrollTop.prototype.show = function() {
        this.$element.addClass(this.settings.activeClass);
        this.active = true;
    };

    /**
     * Hide the button.
     */
    ScrollTop.prototype.hide = function() {
        this.$element.removeClass(this.settings.activeClass);
        this.active = false;
    };


    return ScrollTop;
});

